import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: "primary" | "error" | "warning" | "info" | "success";
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "error",
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 2,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <DialogContentText sx={{ fontSize: "0.875rem" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={onClose}
          size="medium"
          sx={{
            fontSize: "0.8125rem",
            textTransform: "none",
            height: "36px",
            minWidth: "64px",
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={isLoading}
          size="medium"
          sx={{
            fontSize: "0.8125rem",
            textTransform: "none",
            fontWeight: 500,
            height: "36px",
            minWidth: "64px",
          }}
        >
          {isLoading ? "Processing..." : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
